import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({ children, showSidebar = true }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900 flex overflow-hidden">
      {/* Sidebar - Fixed on desktop, hidden on mobile */}
      {showSidebar && (
        <div className="hidden lg:block lg:w-64 lg:flex-shrink-0">
          <Sidebar />
        </div>
      )}
      
      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header - Fixed at top */}
        <Header />
        
        {/* Page content - Scrollable area */}
        <main className="flex-1 overflow-y-auto">
          <div className={`h-full ${isHomePage ? '' : 'p-4 sm:p-6'}`}>
            {children}
          </div>
        </main>
      </div>
      

    </div>
  );
};